import React from "react";
import { Modal, Form, Input } from "antd";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";

class ChangePasswordModal extends React.Component {
  handleOk = () => {
    this.props.onOk(this.props.form.getFieldsValue());
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const intl = this.props.useIntl;

    return (
      <Modal
        className="bp-modal"
        title={intl.formatMessage({id: "app.modal.changepasswordmodal.changepassword"})}
        visible={this.props.visible}
        onOk={this.handleOk}
        onCancel={this.props.onCancel}
        destroyOnClose={true}
        maskClosable={false}
      >
        <Form className="change-password-form" layout="horizontal">
          <Form.Item label={intl.formatMessage({id: "app.modal.changepasswordmodal.currentpassword"})}  hidden={this.props.hiddenCurrentPasword}>
            {getFieldDecorator("currentPassword", {
              rules: [
                {
                  required: true,
                  message: intl.formatMessage({id: "app.message.changepasswordmodal.currentpassword"})
                }
              ]
            })(<Input size={"large"} name="currentPassword" type="password" hidden={this.props.hiddenCurrentPasword}/>)}
          </Form.Item>
         
          <Form.Item label={intl.formatMessage({id: "app.modal.changepasswordmodal.newpassword"})}>
            {getFieldDecorator("password", {
              rules: [
                { required: true, message: intl.formatMessage({id: "app.message.changepasswordmodal.newpassword"}) }
              ]
            })(<Input size={"large"} name="password" type="password" />)}
          </Form.Item>
          
          <Form.Item label={intl.formatMessage({id: "app.modal.changepasswordmodal.repeatpassword"})}>
            {getFieldDecorator("passwordVerification", {
              rules: [
                { required: true, message: intl.formatMessage({id: "app.message.changepasswordmodal.newpassword"}) }
              ]
            })(<Input size={"large"} name="passwordVerification" type="password" />)}
          </Form.Item>
          
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(withUseIntl(ChangePasswordModal));
